import React from 'react';
import { Button, Card } from "react-bootstrap";
import { LinkContainer } from 'react-router-bootstrap';
import ImageBlock from "../ImageBlock/imageBlock.component";
import { retina_student_panel_url } from '../../constants/const'
// import styled from "styled-components";

import './courseCard.module.css';
import { Link } from 'react-router-dom';

const CourseCard = ({ banner, title, subTitle, price, discount, link, id, item, description, session }, ...props) => {
    return (
        <div styleName="course-card-wrap">
            <Card className='course-card' styleName="course-card">
                <Link to={link}>
                    <ImageBlock
                        width={684}
                        height={361}
                        src={banner}
                    />
                </Link>
                <Card.Body className='flex-grow-1'>
                    <Card.Title className="text-truncate" styleName="course-card-title">
                        <LinkContainer to={link}>
                            <Card.Link title={!!title && title}>{!!title && title}</Card.Link>
                        </LinkContainer>
                    </Card.Title>

                    <div styleName="description" dangerouslySetInnerHTML={{ __html: description }}></div>
                </Card.Body>
                <Card.Body className='flex-grow-0'>
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        {/* <LinkContainer to={`/${retina_student_panel_url}/sign-up/${id}`}> */}
                        {/* <a styleName="enroll-btn" className="custom-btn-dark pulse" target="_blank" rel="noreferrer" href={`${retina_student_panel_url}/sign-up?courseModuleId=${id}&title=${title}&description=${description}&price=${price}&discount=${discount}&coverPhoto=${banner}&session=${session}&enroll=${true}`}>Enroll</a> */}
                        {/* </LinkContainer> */}
                        <LinkContainer to={link}>
                            <Button className='course-learn-more d-block w-100'>বিস্তারিত</Button>
                        </LinkContainer>
                    </div>
                    {/* <Card.Link href="#">Another Link</Card.Link> */}
                </Card.Body>
            </Card>
        </div>
    )
}

export default CourseCard;